import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import DocComponent from 'pages/Entrepeneur/Feedbacks/Miscellaneous/DocComponent';
import CompanyModal from './CompanyModal';
import CommentComponent from './CommentComponent';
import NewComment from './NewComment';

import AvatarFaadi from '../../../assets/avatars/fakePersons/AvatarFaadi.png';
import AvatarSlavcho from '../../../assets/avatars/fakePersons/AvatarSlavcho.png';
import AvatarJonathan from '../../../assets/avatars/fakePersons/AvatarJonathan.png';

const useStyles = makeStyles({
  root: {
    minWidth: 675,
    margin: '1.3rem 0',
    padding: 7
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)'
  },
  title: {
    background: '#FFCCD8',
    fontSize: 12,
    fontFamily: 'PT sans',
    color: '#CD0032',
    FontWeight: 'bolder',
    border: '1px solid #FFCCD8',
    borderRadius: 11,
    padding: '0 9px'
  },
  name: {
    fontFamily: 'PT sans',
    fontWeight: 'bold',
    fontSize: 14,
    color: '#0E4EAD',
    cursor: 'pointer'
  },
  status: {
    fontFamily: 'PT sans',
    fontSize: '14px',
    color: '#A7AAAE'
  },
  time: {
    fontFamily: 'PT sans',
    fontSize: '14px',
    color: '#252523'
  },
  option: {
    marginBottom: 25,
    fontFamily: 'PT sans',
    fontWeight: '600',
    fontSize: '16px',
    color: '#002380'
  },
  companyContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 15
  },
  avatar: {
    marginTop: 10,
    marginRight: 10
  }
});

const FeedBack = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const classes = useStyles();

  return (
    <>
      <CompanyModal onClose={() => setModalOpen(false)} open={modalOpen} />
      <Card className={classes.root} elevation={0}>
        <CardContent>
          <div className={classes.container}>
            <Typography className={classes.title} gutterBottom>
              Feedback
            </Typography>
            <Typography className={classes.time} gutterBottom>
              Yesterday at 2:15 PM
            </Typography>
          </div>
          <div className={classes.companyContainer}>
            <Avatar className={classes.avatar}>G</Avatar>
            <div>
              <Typography
                className={classes.name}
                component="h2"
                onClick={() => setModalOpen(true)}
                variant="h5">
                Fidelity
              </Typography>
              <Typography className={classes.status}>Mutual Funds</Typography>
            </div>
          </div>

          <DocComponent
            click={() =>
              window.open(
                'http://drivee.praexo.io/api/demofiles/feedback-Financial%20Analysis.pdf',
                '_blank'
              )
            }
            docName="Model_report.pdf"
            fullWidth
          />
          <DocComponent
            click={() =>
              window.open(
                'http://drivee.praexo.io/api/demofiles/Drivee_Feedback_Fidelity.pdf',
                '_blank'
              )
            }
            docName="Answers_to_the_10_feedbacks_questions.pdf"
            fullWidth
          />
        </CardContent>
        <NewComment />

        <CommentComponent
          avatar={AvatarFaadi}
          date="Yesterday at 6:43 PM"
          name="Faazdi Al Rahman"
          status="Lead Financial Advisor"
          text="This feedback is very useful. It
did conﬁrm the choice we made to focus the equity story on the proﬁtable growth theme.
But Fidelity expects that we provide more information on how you intend to lower capital
intensity in the future"
        />
        <CommentComponent
          avatar={AvatarSlavcho}
          date="Yesterday at 5:59 PM"
          name="Slavcho Karbashewski"
          status="Advisor (Praexo)"
          text="Based on recent feedbacks, we
have identified a growing trend in DCF-based valuations, so it is critical that capital
intensity going forward is better addressed"
        />
        <CommentComponent
          avatar={AvatarJonathan}
          date="Yesterday at 5:49 PM"
          name="Jonathan Wood"
          status="CEO"
          text="Thanks, well noted. I will emphasize on these two topics in my upcoming meeting with Blackrock."
        />
      </Card>
    </>
  );
};

export default FeedBack;
